// lib imports
import React, { Component, Suspense, lazy } from "react"
import { BrowserRouter, Route, Switch, } from "react-router-dom"
import Cookies from "universal-cookie"
import { connect } from 'react-redux'
// lib imports ends

// default components 
import { Profile } from "./Profile"
import Services from "./Services"
import F0F from "./F0F"
import Logout from "./Logout"
import MyProfile from "./Profile/MyProfile"
import * as API from "./api"
import "./App.css"
import { OnIdleHandlerWrapper } from "./helperComponents/OnIdleHandlerWrapper"
import ProfileSettings from './Profile/ProfileSettings'
import userLogin from './userAuth/userLogin'
import ForgotPassword from './userAuth/ForgotPassword'
import ResetPasswordSuccessful from './userAuth/ResetPasswordSuccessful'
import accountActivetionmsg from './userAuth/accountActivetionmsg'
import userSignup from "./userAuth/UserSignUp"
import SideBarComponent from "./ReusableComponents/SideBarComponent.js"
import AeroGCSEnterpriseTeam from "./AeroGCSEnterprise/Components/AeroGCSEnterpriseTeam"
import Feedback from "./Feedback.js"
import editUser from "./Profile/editUser"
import AeroMeghPlans from './AeroMeghPlans'
import Invoice from './Invoice'
import Invoices from './Invoices'
import UsageStatistics from "./UsageStatistics"
import LoaderComponent from "./ReusableComponents/LoaderComponent"
// default components end

// Lazy load route components for code splitting - reduces initial bundle size
//Analytics Tool
const AnalyticUserDetails = lazy(() => import("./AnalyticTool/Components/UserDetails"))
const AnalyticUserLogs = lazy(() => import("./AnalyticTool/Components/UserTrackingLogs"))
const AnalyticScreenLogs = lazy(() => import("./AnalyticTool/Components/UserScreenLogs"))
const UserStatistics = lazy(() => import("./AnalyticTool/Components/UserStatistics"))
const CustomStatistics = lazy(() => import("./AnalyticTool/Components/CustomStatistics"))
//Analytics Tool end

// GCS-E
const DashboardAeroplane = lazy(() => import('./AeroGCSEnterprise/Dashboard/DashboardAeroplane.js'))
const Flights = lazy(() => import("./AeroGCSEnterprise/Flights/Flights.js"))
const Acres = lazy(() => import("./AeroGCSEnterprise/Acres/Acres.js"))
const Pilots = lazy(() => import("./AeroGCSEnterprise/Pilots/Pilots.js"))
const Projects = lazy(() => import("./Projects"))
const Plans = lazy(() => import("./Plans"))
const RMPAllFlightPlans = lazy(() => import("./RMPAllFlightPlans.js"))
const userCustomer = lazy(() => import('./leaseDrones/userCustomer'))
const userCustomerInfo = lazy(() => import('./leaseDrones/userCustomerInfo'))
const userAllLease = lazy(() => import('./leaseDrones/userAllLease'))
const leaseDashboard = lazy(() => import('./leaseDrones/leaseDashboard'))
const leaseDroneMgmt = lazy(() => import('./leaseDrones/leaseDroneMgmt'))
const leaseDroneDetails = lazy(() => import('./leaseDrones/leaseDroneDetails'))
const leaseDroneInvoice = lazy(() => import('./leaseDrones/leaseDroneInvoice'))
const leaseInvoices = lazy(() => import('./leaseDrones/leaseInvoices'))
const AeroGCSGreenDashboard = lazy(() => import("./AeroGCSGreenEnterprise/AeroGCSGreenDashboard"))
const AeroGCSGreenCustomers = lazy(() => import("./AeroGCSGreenEnterprise/AeroGCSGreenCustomers"))
const AeroGCSGreenReports = lazy(() => import("./AeroGCSGreenEnterprise/AeroGCSGreenReports"))
const DrnMgmtDrones = lazy(() => import("./DrnMgmtDrones"))
const DrnMgmtDroneDetails = lazy(() => import("./DrnMgmtDroneDetails"))
const DCCAllDrones = lazy(() => import("./DCCAllDrones"))
const DCCAllFeeds = lazy(() => import("./DCCAllFeeds"))
const DCCFeed = lazy(() => import("./DCCFeed"))
const DCCDroneFlyView = lazy(() => import('./DCCDroneFlyView'))
const RMSelectLocation = lazy(() => import("./RMSelectLocation"))
const RMFlightPlan = lazy(() => import("./RMFlightPlan"))
const RMAssignDrone = lazy(() => import('./RMAssignDrone'))
const RMDetailedLog = lazy(() => import('./RMDetailedLog'))
const RMFlightDetails = lazy(() => import('./RMFlightDetails'))
const RMPMyVideos = lazy(() => import('./RMPMyVideos'))
const RMPMyImages = lazy(() => import('./RMPMyImages'))
const RMPFlightCompletedHours = lazy(() => import('./RMPFlightCompletedHours'))
const RMPSurveyFlightPlan = lazy(() => import('./RMPSurveyFlightPlan.js'))
const RMPSprayinhFlightPlan = lazy(() => import('./RMPSprayinhFlightPlan.js'))
const RMPSprayingFlightPlot = lazy(() => import('./RMPSprayingFlightPlot.js'))
const RMPLiveVideoStramingURL = lazy(() => import("./RMPLiveVideoStramingURL"))
const IncidentReport = lazy(() => import("./incident/IncidentReport"))
const NewIncident = lazy(() => import("./incident/NewIncident"))
const IncidentReportDetail = lazy(() => import("./incident/IncedentReportDetail"))
const RMPImage_collection = lazy(() => import("./RMPImage_collection"))
// GCS E end

//admin tool 
const AdminUsers = lazy(() => import("./AdminUsers.js"))
const AdminEditUsers = lazy(() => import("./AdminEditUsers.js"))
const AdminUserDetails = lazy(() => import("./AdminUserDetails.js"))
const AdminUserTrackingLogs = lazy(() => import('./AdminUserTrackingLogs.js'))
const AdminUserScreenLog = lazy(() => import('./AdminUserScreenLog.js'))
const AdminAddChangeSubscription = lazy(() => import('./AdminAddChangeSubscription.js'))
const AdminAssignService = lazy(() => import("./AdminAssignService.js"))
const allSubscription = lazy(() => import('./subscription/allSubscription'))
const subscriptiontems = lazy(() => import('./subscription/subscriptiontems'))
const newSubscription = lazy(() => import('./subscription/newSubscription'))
const DiscountCoupons = lazy(() => import("./subscription/DiscountCoupons"))
const TaskAndVmList = lazy(() => import('./TaskAndVmList'))
const FlightErrorLogs = lazy(() => import("./FlightErrorLogs.js"))
const WeeklyReport = lazy(() => import("./AeroGCSEnterprise/WeeklyReport/WeeklyReport.js"))
const AdminSoftwareVersions = lazy(() => import("./AdminSoftwareVersions.js"))
const AdminAllDronesLocations = lazy(() => import("./AdminAllDronesLocations.js"))
const AdminDroneFlightLocations = lazy(() => import("./AdminDroneFlightLocations.js"))
const AdminPanel = lazy(() => import("./AdminPanel.js"))
const CropAndAgrochemicals = lazy(() => import("./CropAndAgrochemicals.js"))
const UserFlightLocations = lazy(() => import("./AeroGCSEnterprise/Drones/UserFlightLocations.js"))
const TeamGivenAcces = lazy(() => import("./AeroGCSEnterprise/Components/TeamGivenAccess.js"))
const AdminDCCAllDrones = lazy(() => import("./AeroGCSEnterprise/AdminDCCAllDrones.js"))
const AdminDCCDroneFlyView = lazy(() => import("./AeroGCSEnterprise/AdminDCCDroneFlyView.js"))
const AdminUsersEmailLogs = lazy(() => import("./AdminUsersEmailLogs.js"))
// admin tool end

const PaymentSuccessful = lazy(() => import("./Payments/PaymentSuccessful.jsx"))
const PaymentFailed = lazy(() => import("./Payments/PaymentFailed.jsx"))
const DrnHealthReport = lazy(() => import("./DrnHealthReport.js"))
const UnregisteredDrones = lazy(() => import("./UnregisteredDrones.js"))
const LogAnalyzer = lazy(() => import('./AeroGCSEnterprise/Components/LogAnalyzer.js'))
const DroneHardwareDetails = lazy(() => import('./AeroGCSEnterprise/Drones/DroneHardwareDetails.js'))
const AdminDrones = lazy(() => import("./AdminDrones.js"))
class App extends Component {
  state = {
    done: false,
    teamsLoaded: false,
    serviceLoad: [],
    adminService: false,
    stateRoutes: [
      { path: "/teams", componentToMount: AeroGCSEnterpriseTeam },
      { path: "/teams/givenAccess", componentToMount: TeamGivenAcces },
      { path: "/feedback", componentToMount: Feedback, },
      { path: "/logout", componentToMount: Logout, },
      { path: "/my_profile", componentToMount: MyProfile, },
      { path: "/edit_profile", componentToMount: editUser, },
      { path: "/aeroGCS_plans", componentToMount: AeroMeghPlans, },
      { path: "/invoice", componentToMount: Invoice, },
      { path: "/invoices", componentToMount: Invoices, },
      { path: "/usage_statistics", componentToMount: UsageStatistics, },
      { path: "/profile-settings", componentToMount: ProfileSettings },
      { path: "/payment/success", componentToMount: PaymentSuccessful },
      { path: "/payment/failed", componentToMount: PaymentFailed },
    ],
  }
  // Memoize cookie check to avoid recreating Cookies instance
  cookie = new Cookies()
  
  isUserLoggedIn = () => {
    const sessionCookie = this.cookie.get("session_IAMAero")
    const href = window.location.href
    return !(sessionCookie == "" ||
      !sessionCookie ||
      href.includes("/login") ||
      href.includes("/signup") ||
      href.includes("/forgotPassword") ||
      href.includes("/accountActivated") ||
      href.includes("/resetPasswordSuccessful") ||
      href.includes("/accept_Inv") ||
      href.includes("/live_camera_feed")
    )
  }
  componentWillMount() {
    const sessionCookie = this.cookie.get("session_IAMAero")

    if (window.location.href.includes("/login") || window.location.href.includes("/signup") || window.location.href.includes("/forgotPassword") || window.location.href.includes("/accountActivated") || window.location.href.includes("/resetPasswordSuccessful")) {
      if (sessionCookie == "" || !sessionCookie) {
        let routes = this.state.stateRoutes
        routes.push({ path: "/login", componentToMount: userLogin })
        routes.push({ path: "/signup", componentToMount: userSignup })
        routes.push({ path: "/forgotPassword", componentToMount: ForgotPassword })
        routes.push({ path: "/accountActivated", componentToMount: accountActivetionmsg })
        routes.push({ path: "/resetPasswordSuccessful", componentToMount: ResetPasswordSuccessful })

        this.setState({
          done: true,
          hideProfile: true,
          stateRoutes: routes,
        })
      } else {
        API.sessionCheck().then((response) => {
          if (response?.access_token && response?.access_token != "") {
            window.location.replace("/")
          } else {
            this.cookie.set('session_IAMAero', "", { path: '/' })
            sessionStorage.clear();
            localStorage.clear()
            window.location.replace("/login")
          }
        }).catch((err) => {
          console.log("session inactive", err)
          this.cookie.set('session_IAMAero', "", { path: '/' })
          sessionStorage.clear();
          localStorage.clear()
          window.location.replace("/login")
        })
      }
    } else if (window.location.href.includes("/live_camera_feed")) {
      let routes = this.state.stateRoutes
      routes.push({ path: "/live_camera_feed", componentToMount: RMPLiveVideoStramingURL })

      this.setState((state) => ({
        ...state,
        done: true,
        hideProfile: true,
        stateRoutes: routes,
      }))
    } else if (sessionCookie == "") {
      window.location.replace("/login")
      return <div />
    } else {
      API.getUserSubbedServices().then((response) => {
        let services = response[0]
        this.setState((prev) => ({
          ...prev,
          services,
          adminService: (services.filter((service) => service.title == "Admin Tools")).length > 0 ? true : false,
          serviceLoad: services.filter((service) => service.title == "Admin Tools" || service.title == 'Analytic Tool')
        }), () => {
          let routes = this.state.stateRoutes
          if (services.length) {
            return services.forEach((service, key) => {
              if (service.title == "Admin Tools") {
                routes.push({ path: "/admin", componentToMount: AdminPanel, })
                routes.push({ path: "/admin/drones", componentToMount: AdminDrones, })
                routes.push({ path: "/admin/drone_control_center/all_drones", componentToMount: AdminDCCAllDrones })
                routes.push({ path: "/admin/drone_control_center/fly_view", componentToMount: AdminDCCDroneFlyView })
                routes.push({ path: "/admin/cropsAndAgrochemicals", componentToMount: CropAndAgrochemicals, })
                routes.push({ path: "/admin/users", componentToMount: AdminUsers, })
                routes.push({ path: "/admin/email_logs", componentToMount: AdminUsersEmailLogs })
                routes.push({ path: "/admin/machines", componentToMount: TaskAndVmList, })
                routes.push({ path: "/admin/allSubscription", componentToMount: allSubscription, })
                routes.push({ path: "/admin/new_subscription", componentToMount: newSubscription, })
                routes.push({ path: "/admin/discount_coupons", componentToMount: DiscountCoupons, })
                routes.push({ path: "/admin/subscription_items", componentToMount: subscriptiontems, })
                routes.push({ path: "/admin/userdetails", componentToMount: AdminUserDetails, })
                routes.push({ path: "/admin/user_tracking_logs", componentToMount: AdminUserTrackingLogs, })
                routes.push({ path: "/admin/user_screen_logs", componentToMount: AdminUserScreenLog, })
                routes.push({ path: "/admin/edituser", componentToMount: AdminEditUsers, })
                routes.push({ path: "/admin/assign_services", componentToMount: AdminAssignService, })
                routes.push({ path: "/admin/user_manage_plan", componentToMount: AdminAddChangeSubscription, })
                routes.push({ path: "/admin/software_versions", componentToMount: AdminSoftwareVersions, })
                routes.push({ path: "/admin/OEMUser", componentToMount: UnregisteredDrones, })
                routes.push({ path: "/admin/all_drones_locations", componentToMount: AdminAllDronesLocations, })
                routes.push({ path: "/admin/drone_flight_locations", componentToMount: AdminDroneFlightLocations, })
              } else if (service.title == 'Analytic Tool') {
                routes.push({ path: "/analytictool/user_statistics", componentToMount: UserStatistics })
                routes.push({ path: "/analytictool/userdetails", componentToMount: AnalyticUserDetails })
                routes.push({ path: "/analytictool/user_tracking_logs", componentToMount: AnalyticUserLogs })
                routes.push({ path: "/analytictool/user_screen_logs", componentToMount: AnalyticScreenLogs })
                routes.push({ path: "/analytictool/customStatistics", componentToMount: CustomStatistics })
              } else if (service.title == 'AeroGCS Enterprise') {
                routes.push({ path: "/", componentToMount: DashboardAeroplane })
                routes.push({ path: "/aerogcsenterprise/user_flight_locations", componentToMount: UserFlightLocations, })
                routes.push({ path: "/aerogcsenterprise/flights", componentToMount: Flights })
                routes.push({ path: "/aerogcsenterprise/flights/acres", componentToMount: Acres })
                routes.push({ path: "/aerogcsenterprise/flights/pilots", componentToMount: Pilots, })
                routes.push({ path: "/aerogcsenterprise/projects", componentToMount: Projects })
                routes.push({ path: "/aerogcsenterprise/plans", componentToMount: Plans })
                routes.push({ path: "/aerogcsenterprise/allFlightPlans", componentToMount: RMPAllFlightPlans })
                routes.push({ path: "/aerogcsenterprise/drones", componentToMount: DrnMgmtDrones, })
                routes.push({ path: "/aerogcsenterprise/drone_details", componentToMount: DrnMgmtDroneDetails, })
                routes.push({ path: "/aerogcsenterprise/drone/drone_health_report", componentToMount: DrnHealthReport, })
                routes.push({ path: "/aerogcsenterprise/drone/errorLogs", componentToMount: FlightErrorLogs, })
                routes.push({ path: "/aerogcsenterprise/reports", componentToMount: WeeklyReport, })
                routes.push({ path: '/aerogcsenterprise/flight_logAnalyzer', componentToMount: LogAnalyzer })
                routes.push({ path: '/aerogcsenterprise/drone/hardwareDetails', componentToMount: DroneHardwareDetails })
                routes.push({ path: "/aerogcsenterprise/lease_dashboard", componentToMount: leaseDashboard })
                routes.push({ path: "/aerogcsenterprise/lease_dronesLease", componentToMount: userAllLease })
                routes.push({ path: "/aerogcsenterprise/lease_customers", componentToMount: userCustomer })
                routes.push({ path: "/aerogcsenterprise/lease_customer", componentToMount: userCustomerInfo })
                routes.push({ path: "/aerogcsenterprise/lease_dronesMgmt", componentToMount: leaseDroneMgmt })
                routes.push({ path: "/aerogcsenterprise/lease_drone_details", componentToMount: leaseDroneDetails })
                routes.push({ path: "/aerogcsenterprise/lease_drone_invoices", componentToMount: leaseInvoices })
                routes.push({ path: "/aerogcsenterprise/lease_drone_invoice", componentToMount: leaseDroneInvoice })
                routes.push({ path: "/aerogcsenterprise/green_dashboard", componentToMount: AeroGCSGreenDashboard })
                routes.push({ path: "/aerogcsenterprise/green_all_customers", componentToMount: AeroGCSGreenCustomers })
                routes.push({ path: "/aerogcsenterprise/green_all_reports", componentToMount: AeroGCSGreenReports })
                routes.push({ path: "/aerogcsenterprise/drone_control_center/all_drones", componentToMount: DCCAllDrones })
                routes.push({ path: "/aerogcsenterprise/drone_control_center/all_feeds", componentToMount: DCCAllFeeds })
                routes.push({ path: "/aerogcsenterprise/drone_control_center/fly_view", componentToMount: DCCDroneFlyView })
                routes.push({ path: "/aerogcsenterprise/drone_control_center/feed", componentToMount: DCCFeed })
                routes.push({ path: "/aerogcsenterprise/remote_mission/selectLocation", componentToMount: RMSelectLocation, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/image_collection", componentToMount: RMPImage_collection, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/flightPlan", componentToMount: RMFlightPlan, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/assignDroneToPlan", componentToMount: RMAssignDrone, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/flightLogs", componentToMount: Flights, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/detailedlog", componentToMount: RMDetailedLog, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/flight_details", componentToMount: RMFlightDetails, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/my_videos", componentToMount: RMPMyVideos, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/my_images", componentToMount: RMPMyImages, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/surveyFlightPlan", componentToMount: RMPSurveyFlightPlan, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/sprayingFlightPlan", componentToMount: RMPSprayinhFlightPlan, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/sprayingFlightPlot", componentToMount: RMPSprayingFlightPlot, })
                routes.push({ path: "/aerogcsenterprise/remote_mission/flights_completed_hours", componentToMount: RMPFlightCompletedHours, })
                routes.push({ path: "/aerogcsenterprise/incidentReport", componentToMount: IncidentReport, })
                routes.push({ path: "/aerogcsenterprise/incidentReportDetail", componentToMount: IncidentReportDetail, })
                routes.push({ path: "/aerogcsenterprise/newIncidentReport", componentToMount: NewIncident, })
              }
              if (key == services.length - 1) {
                this.setState({
                  done: true,
                  stateRoutes: routes,
                })
              }
            })
          } else {
            this.setState({
              done: true,
              stateRoutes: routes,
            })
          }
        })
      },
        (e) => {
          window.location.replace("/login")
        }
      )
    }
  }

  render() {
    let routes = this.state.stateRoutes
    if (this.state.done) {
      return (
        <>
          <BrowserRouter>
            <OnIdleHandlerWrapper>
              {this.state.hideProfile ? <></> :
                <Profile teamsLoaded={() => this.setState({ teamsLoaded: true })} />}
              {<SideBarComponent adminService={this.state.adminService} />}
              {this.state.teamsLoaded || !this.isUserLoggedIn() ?
                <Suspense fallback={<LoaderComponent height={'90vh'} />}>
                  <Switch>
                    <Route exact path="/" component={DashboardAeroplane} />
                    {routes.map((route, key) => (
                      <Route exact key={key} path={route.path} component={route.componentToMount} />
                    ))}
                    <Route component={F0F} />
                  </Switch>
                </Suspense>
                : <LoaderComponent height={'90vh'} />}
            </OnIdleHandlerWrapper>
          </BrowserRouter>
        </>
      )
    }
    else {
      return <LoaderComponent height={'90vh'} />
    }
  }
}

const mapStateToProps = (state) => ({
  user: state.profile.user
});

export default connect(mapStateToProps)(App);